module.exports = __webpack_public_path__ + "static/img/avatar.dfb7f57d.png";